/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState,useEffect } from "react";
import { useNavigate,Link } from 'react-router-dom';
import axios from 'axios';

import Header from "../../components/includes/Header";
import HeaderTitle from "../../components/includes/HeaderTitle";
import LeaveMember from "../../components/popups/LeaveMember";

import { LoginAfterCheckLogin,ChangeMobileFormat } from "../../components/common/Common";

import "../../css/style.css";

const MyInfo = () => {
  LoginAfterCheckLogin(1);  //로그인 상태 점검

  const mem_idx = Number(localStorage.getItem("mem_idx"));
  const navigate = useNavigate();

  //회원정보 저장 객체
  const newMember = {mem_idx:mem_idx,mem_mode:1,mem_id:"",chk_id:0,mem_name:"",mem_mobile:"",mem_email:"",mem_device:""};

  //회원정보
  const [varMember,setMember] = useState({});

  const [varOpenLeave,setOpenLeave] = useState(false);

  //회원정보 읽어오기
  const getInformation = async () => {
    const sendData = {mem_idx:mem_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_my_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        setMember(datas.results);
      }
    });
  }

  //FCM TOKEN 메모리에 저장
  const eventFromAndroid = async (e) => {
    localStorage.setItem('fcm_token',e.detail.token);
  }

  //최초실행부
  useEffect(() => {
    setMember(newMember);

    //네이티브에 기기코드 요청
    const mobileType = navigator.userAgent.toLowerCase();
    console.log(mobileType);
    if (mobileType.indexOf('android') > -1) {
      if(window.betterLogis){
        //안드로이드로부터 받기
        window.addEventListener("onFcmInfoSuccess", eventFromAndroid);
        //안드로이드로 보내기
        window.betterLogis.getFcmInfo();
      } 
    } else if (mobileType.indexOf('iphone') > -1 || mobileType.indexOf('ipad') > -1 || mobileType.indexOf('ipod') > -1) {
      //alert(window.webkit);
      if(window.webkit) window.webkit.messageHandlers.getFcmInfo.postMessage('');
    } 

    getInformation();
    return () => {
      if(window.betterLogis){
        window.removeEventListener("onFcmInfoSuccess",eventFromAndroid);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //입력값 처리
  const onChangeInputHandler = (e) => {
    const { name,value } = e.currentTarget;
    setMember({...varMember,[name]:value});
  }

  //정보저장
  const onUpdateMyInformationHandler = async(e) => {
    e.preventDefault();
    if (varMember.mem_name === "") {
      alert('회원명을 먼저 입력하세요'); return false; 
    } else if (varMember.mem_id === "") {
      alert('회원 ID를 먼저 입력하십시오.'); return false;
    } else if (varMember.chk_id === 0) {
      alert('회원ID의 중복검사를 먼저 실행하십시오.'); return false;    
    } else if (varMember.dr_carnumb === '') {
      alert('차량번호를 먼저 입력하십시오.'); return false;      
    }

    if(!window.confirm('회원정보를 저장하시겠습니까?')) return false;

    const mem_device = localStorage.getItem('fcm_token');
    const sendData = {mem_idx:mem_idx,memberInfo:varMember,mem_device:mem_device};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_update_my_information`,sendData).then((res) => {
      const datas = res.data;
      if(datas.retvalue === 1) {
        //자동로그인
        localStorage.setItem("mem_id", varMember.mem_id);
        localStorage.setItem("mem_name", varMember.mem_name);
        localStorage.setItem("mem_mobile", varMember.mem_mobile);
        localStorage.setItem("mem_carnumb", varMember.dr_carnumb);
        //페이지이동
        navigate(`/MyPage`);
      } else {
        alert(datas.message);
      }
    });
  }
  //회원탈퇴 -  팝업창
  const onOpenLeaveHandler = (e,bmode) => {
    e.preventDefault();
    setOpenLeave(bmode);
  }
  //회원탈퇴
  const onLeaveMemberHandler = async(e) => {
    if(!window.confirm('회원탈퇴하시겠습니까?')) return false;
    setOpenLeave(false);
    const sendData = {mem_idx:mem_idx};
    await axios.post(`${process.env.REACT_APP_HOST}/_leave_member`,sendData).then((res) => {
      const datas = res.data;
      if(datas.retvalue === 1) {
        localStorage.removeItem("mem_idx");
        localStorage.removeItem("mem_id");
        localStorage.removeItem("mem_name");
        localStorage.removeItem("mem_mobile");
        localStorage.removeItem("mem_mode");
        localStorage.removeItem("mem_type");
        localStorage.removeItem("mem_company");
        localStorage.removeItem("userLoginState");
        localStorage.removeItem("autoLogin");
        navigate('/Login');
      } else {
        alert(datas.message);
      }
    });
  }

  return(
    <div className="vh-container">
      <Header varGoToMain={true} />
      <div className="vh-content">
        <HeaderTitle varPageTitle={'개인 정보 수정'} varBackString={'/MyPage'}/>
        <div className="vh-content-body">
          <div className="form-group mb25 ms25">
						<label className="form-label">아이디</label>
						<div className="field-group">{varMember.mem_id||""}</div>
					</div>
          <div className="form-group mb25 ms25">
						<label className="form-label">이름</label>
						<div className="field-group">
							<input type="text" name="mem_name" className="form-value" value={varMember.mem_name||""}  onChange={onChangeInputHandler}/>
						</div>
					</div>
          <div className="form-group mb25 ms25">
            <label className="form-label">휴대폰 번호</label>
            <div className="field-group">
              <Link to="/ChangeMobile" className="form-control-btn active">정보 변경</Link>
              <input type="text" name="mem_mobile" className="form-value" value={ChangeMobileFormat(varMember.mem_mobile||"")}  onChange={onChangeInputHandler}/>
            </div>
          </div>
          <div className="form-group mb25 ms25">
						<label className="form-label">차량번호</label>
						<div className="field-group">
							<input type="text" name="dr_carnumb" className="form-value" value={varMember.dr_carnumb||""}  onChange={onChangeInputHandler}/>
						</div>
					</div>
          <div className="form-contoller flex-vertical ms25">
            <Link to="/EditPWD/1" className="form-contoller-btn btn-white">비밀번호 변경</Link>
            <button className="form-contoller-btn mb10" onClick={e=>onUpdateMyInformationHandler(e)}>정보 저장</button>
            <div style={{width:"100%",display:"flex",justifyContent:"right"}}>
              <button className="signout-text mt-auto" onClick={e=>onOpenLeaveHandler(e,true)}>회원탈퇴</button>
            </div>
          </div>
        </div>
      </div>
      <LeaveMember varOpenLeave={varOpenLeave} onOpenLeaveHandler={onOpenLeaveHandler} onLeaveMemberHandler={onLeaveMemberHandler}/>
    </div>
  );
}
export default MyInfo;